import PropTypes from 'prop-types'
import React from 'react'

export default function DetailPageLayoutTemplate (props) {
  const {
    rowOne,
    rowTwo,
    rowThree = null,
    rowFour,
  } = props

  return (
    <div className="detail-page-layout-template">
      <div className="detail-page-layout-template__top">
        {rowOne}
      </div>
      <div className={`detail-page-layout-template__content${rowThree ? ' detail-page-layout-template__content--narrow' : ''}`}>
        <div className="detail-page-layout-template__center">
          {rowTwo}
        </div>
      </div>
      {rowThree && (
        <div className="detail-page-layout-template__right">
          {rowThree}
        </div>
      )}
      <div className="detail-page-layout-template__bottom">
        {rowFour}
      </div>
    </div>
  )
}

DetailPageLayoutTemplate.propTypes = {
  rowOne: PropTypes.node.isRequired,
  rowTwo: PropTypes.node.isRequired,
  rowThree: PropTypes.node,
  rowFour: PropTypes.node,
}
